export default "__VITE_ASSET__A2Ecr6yI__"